'use es6';

import { createLogOnce } from "./createLogOnce.js";
export const warn = createLogOnce('warn', 'Base UI');
export { reset } from "./createLogOnce.js";